module.exports = __webpack_public_path__ + "static/media/verthree.221b248c.svg";